module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"sizeAfterCompressed":"壓縮後: {size} KB (長度: {len})"},"en":{"sizeAfterCompressed":"{size} KB after compressed (length: {len})"}}')
  delete Component.options._Ctor
}
